module.exports = __webpack_public_path__ + "img/icon-twitter.064c3171.svg";